// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"styles_imageWrapper__SGjsh","infoPill":"styles_infoPill__7-rRv"};